import adresseGeoCoder from '@/services/general/adresseGeoCoder';
import { getCommandesByClient } from '@/api/commandes';
import gestionErreur from '@/services/general/gestionErreur';
import * as types from './client-mutation-type';
import * as allTypes from '../mutation-type';
import { browseDetailClient } from '../../api/clients/index';

function initialState() {
  return {
    client: null,
    commandesRapides: [],
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [allTypes.RESET_STATE]() {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [allTypes.RESET_NOT_PERSISTED](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_CLIENT](state, client) {
    state.client = client;
  },
  [types.SET_COMMANDES](state, commandesRapides) {
    state.commandesRapides = commandesRapides;
  },
};

const actions = {
  rechercheDetailClient: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      browseDetailClient(payload.cliNum).then((response) => {
        if (response.data.latitude && response.data.longitude) {
          response.data.position = { lat: response.data.latitude, lng: response.data.longitude };
          commit(types.SET_CLIENT, response.data);
          resolve();
          return;
        }
        const address = response.data.adrLibelle1 + ' ' +
          response.data.adrCp + ' ' +
          response.data.adrVille;
        adresseGeoCoder(address).then((position) => {
          response.data.position = position;
          commit(types.SET_CLIENT, response.data);
          resolve();
        }).catch(() => {
          commit(types.SET_CLIENT, response.data);
          resolve();
        });
      }).catch((e) => {
        reject(e.code);
        gestionErreur(`Erreur lors de la récupération du client n°${payload.cliNum}`, e);
      });
    });
  },
  // Attention ne devrait pas être là
  // dévrait être uniquement dans l'écran de détail client
  async rechercheCommandesByClient({ rootGetters, commit }, payload) {
    const data = {
      query: {
        tiersId: payload.cliNum,
      },
      limit: 5,
      ascending: 1,
      page: 1,
      byColumn: 1,
    };
    const response = await getCommandesByClient(rootGetters['user/userEmail'], data, payload.cliNum);
    commit(types.SET_COMMANDES, response.data);
  },
};

const getters = {
  client: (state) => {
    return state.client;
  },
  commandesRapides: (state) => {
    return state.commandesRapides;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/client.js